import { useState, useEffect } from "react";
import dayjs from 'dayjs';

import { Form, Spin, Card, Row, Col, Input, Button } from "antd";
import { PageHeader } from '@ant-design/pro-components';
import { UserOutlined } from '@ant-design/icons';
import { useNavigate } from "react-router-dom";

import { apiCand } from "../../../services/apiCand";
import { maskCpf } from "../../../utils/maskFunctions";
import { getEntidadesAtivas } from "../../../auth/entidadeUsuario";
import "../style.css";

import { ITipoFuncao } from "../Componentes/InterfaceOutroCargo";

import CadInfoBotoes from "../Componentes/CadInfoBotoes";
import OutroCargoPerfil from "../Componentes/OutroCargoPerfil";

import { resetColor } from "../../../styles/cnpjColor";
import { errorMessage, successMessage, mostrarInfo, mostrarInfoDetail } from "../../../utils/messages";
import { IErroApi, IAreaConhecimento } from "../../../Interfaces/Interfaces";

import { onlyNumbers } from "../../../utils/utilsFunctions";
import PessoaFisicaDadosPessoaisComplementares from "../../PessoaFisica/Componentes/PessoaFisicaDadosPessoaisComplementares";
import { useLocation } from "react-router";
import { getAreasConhecimento, getTiposFuncoes } from "../../../services/apiAuxiliar";
import { IEntidade } from "../../../Interfaces/DadosPrevicInterfaces";

const Cadastrar = (props: any) => {
  const navigate = useNavigate();
  const { state } = useLocation();

  const [form] = Form.useForm();
  const [OutroCargoRetPosCadastro, setOutroCargoRetPosCadastro] = useState([]);

  const [manter, setManter] = useState(1); // 1 : Inserir / 2 : Consultar / 3 : Editar;
  const [erroApi, setErroApi] = useState<IErroApi>()

  const [estadoErroApi, setEstadoErroApi] = useState(0)
  const [msgErroApi, setMsgErroApi] = useState("")

  const [mostrarDetalhesPessoaFisica, setMostrarDetalhesPessoaFisica] = useState(false)

  const [entidades, setEntidades] = useState<IEntidade[]>([]);
  const [areasConhecimento, setAreasConhecimento] = useState<IAreaConhecimento[]>([]);
  const [tiposFuncoes, setTiposFuncoes] = useState<ITipoFuncao[]>([]);


  useEffect(() => {
    if (state && state.nuCpf && state.nuCpf !== "") {
      form.setFieldsValue({
        "nuCpf": maskCpf(state.nuCpf),
        "nmPessoaFisica": state.nmPessoaFisica,
      });
    }

    const entidadeUsuario = getEntidadesAtivas();
    setEntidades(entidadeUsuario);
    if (entidadeUsuario.length === 1){
      form.setFieldsValue({
        "matriculaEfpc": entidadeUsuario[0].matricula,
        "sigla": entidadeUsuario[0].sigla,
      });
    }
    
    getAreasConhecimento(setAreasConhecimento, setLoading);
    getTiposFuncoes(setTiposFuncoes, setLoading);
  }, []);

  useEffect(() => {
    if (OutroCargoRetPosCadastro.length !== 0) pushToManter(OutroCargoRetPosCadastro);
  }, [OutroCargoRetPosCadastro]);

  function pushToManter(outroCargo: any) {  // ABRE A TELA DE DETALHES DO DIRETOR
    let tpSelecao = {
      nuCpf: onlyNumbers(form?.getFieldValue("nuCpf")),
      nmPessoaFisica: form?.getFieldValue("nmPessoaFisica").toUpperCase(),
      matriculaEfpc: form?.getFieldValue("matriculaEfpc"),
      sigla: form?.getFieldValue("sigla").toUpperCase(),
      manter: 2,
      data: outroCargo
    }
    navigate("/outro-cargo/manter", { state: tpSelecao });
  }

  useEffect(() => {
    if (erroApi) {
      if (estadoErroApi === 400) {
        mostrarInfoDetail("Erro de Requisição", erroApi);
      } else if (estadoErroApi === 401) {
        mostrarInfo("Erro de Acesso", "Não autorizado. Tente fazer o login novamente. Mensagem do servidor: " + msgErroApi);
      } else if (estadoErroApi === 403) {
        mostrarInfo("Erro de Acesso", "O acesso ao recurso é proibido. Mensagem do servidor: " + msgErroApi);
      } else {
        mostrarInfo("Erro de comunicação", "Verifique na opção consulta se o cadastro foi efetivado. Mensagem do servidor: " + msgErroApi);
      }
      setErroApi(undefined);
      setEstadoErroApi(0);
      setMsgErroApi("");

    }
  }, [erroApi])

  // Flag para disparar o Carregamento da Pagina
  const [loading, setLoading] = useState(false);
  const [tipLoading, setTipLoading] = useState("");

  const [touched, setTouched] = useState(true);

  const onFinishFailed = () => {
    errorMessage("Campo obrigatório não preechido");
  };

  const sendForm = async () => {
    setTipLoading("Salvando dados ...");
    setLoading(true);
    const json = {
      idOutroCargo: -1,
      idPessoaFisica: state.idPessoaFisica,
      matriculaEfpc: form?.getFieldValue("matriculaEfpc"),
      idAreaConhecimento: form?.getFieldValue("idAreaConhecimento"),
      idTipoFuncao: form?.getFieldValue("idTipoFuncao"),
      cnpj: onlyNumbers(form?.getFieldValue("nuCnpj")),
      dtInicioAtuacao: form?.getFieldValue("dtInicioAtuacao") ? dayjs(form?.getFieldValue("dtInicioAtuacao")).format("YYYY-MM-DD") : "",
      dtFimAtuacao: form?.getFieldValue("dtFimAtuacao") ? dayjs(form?.getFieldValue("dtFimAtuacao")).format("YYYY-MM-DD") : "",
      statusReg: 1,
    };
    // console.log("Subindo json");
    // console.log(json);

    await apiCand.post(`/outroCargo`, json).then((response) => {
      setLoading(false);

      if (response.data.status === 206) {
        setEstadoErroApi(response.data.status);
        setMsgErroApi(response.data.message);
        setErroApi(response.data);
      } else {
        resetForm();
        successMessage(
          `Outro Cargo ${form?.getFieldValue("nmPessoaFisica")} (${maskCpf(form.getFieldValue("nuCpf"))}) cadastrado com Sucesso`
        );
        setOutroCargoRetPosCadastro(response.data);
      }
    })
      .catch(err => {
        let data: IErroApi = err.response.data;
        let msgErro = data.mensagem ? data.mensagem : err.response.data.message;
        let msgDetalheErro = data.campos ? ". " + data.campos[0].cmensagem : "";
        setEstadoErroApi(err.response.status);
        setMsgErroApi(msgErro + msgDetalheErro);
        if (err.response.status < 500) {
          setErroApi(data);
        } else {
          errorMessage(msgErro);
        }
        setLoading(false);
      });
  };

  const resetForm = () => {
    setLoading(true);
    form.getFieldsValue();
    form.setFieldsValue({
      matriculaEfpc: undefined,
      nuCnpj: undefined,
      idTipoFuncao: undefined,
      dtInicioAtuacao: undefined,
    });
    setLoading(false);
    window.scrollTo(0, 0)
  };

  return (
    <>
      {/* <Prompt
        message="Tem certeza de que deseja sair da página? Podem existir dados não salvos."
      /> */}

      <Spin spinning={loading} tip={tipLoading}>
        <PageHeader
          className="site-page-header"
          title="Cadastrar Outros Cargos"
          style={{
            marginTop: "-18px",
            background: "#2160BD",
            padding: 5,
            paddingLeft: 24,
          }}
        />

        <Card variant="borderless" style={{ width: "100%" }}>

          <Form
            layout='vertical'
            form={form}
            style={{ padding: 24 }}
            onFinish={sendForm}
            onFinishFailed={onFinishFailed}
            scrollToFirstError
          >

            <Card title={"Dados Pessoais"}>

              <Row>
                <Col xs={24} xl={8}>
                  <Form.Item hidden={true} name="nuCpf"></Form.Item>
                  <Form.Item hidden={true} name="nmPessoaFisica"></Form.Item>

                  <Form.Item label="CPF" name="cpfDisabled">
                    <Input defaultValue={maskCpf(state.nuCpf)} disabled={true} />
                  </Form.Item>
                </Col>

                <Col xs={24} xl={12}>
                  <Form.Item label="Nome Completo" name="nmPessoaFisicaDisabled">
                    <Input defaultValue={state.nmPessoaFisica} disabled={true} />
                  </Form.Item>
                </Col>

                <Col xs={24} xl={4} >
                  <Form.Item style={{ alignItems: 'center' }}
                    label="Detalhar Cadastro de Pessoa Física"
                  >
                    <Button
                      shape='round'
                      onClick={() => {
                        setMostrarDetalhesPessoaFisica(!mostrarDetalhesPessoaFisica);
                      }}
                      type='primary'
                      icon={<UserOutlined />}
                    />
                  </Form.Item>

                </Col>

              </Row>
            </Card>

            <Row style={{ display: mostrarDetalhesPessoaFisica ? 'inline' : 'none' }} >
              <>
                <PessoaFisicaDadosPessoaisComplementares
                  form={form}
                  idPessoaFisica={state.idPessoaFisica}
                  mostrarDetalhesPessoaFisica={mostrarDetalhesPessoaFisica}
                />
              </>
            </Row>

            <Card title={"Dados do Cargo/Função"}>
              <>
                <OutroCargoPerfil
                  form={form}
                  entidades={entidades}
                  tiposFuncoes={tiposFuncoes}
                  areasConhecimento={areasConhecimento}
                  manter={manter}
                  dadosOutroCargo={undefined}
                />
              </>
            </Card>

            <CadInfoBotoes
              resetForm={resetForm}
              detalhar={false}
              form={form}
              desabilitar={touched}
              setDesabilitar={setTouched}
              resetColor={resetColor}
              manter={manter}
              setManter={setManter}
            />

          </Form>
        </Card>
      </Spin>

    </>
  );
};

export default Cadastrar;